module.exports = __webpack_public_path__ + "static/img/pos_banner.11c7733.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_banner.png
// module id = z26x
// module chunks = 8